// @ts-check

import { paginator, downLayoutAgentBuilder } from './paginator';
import { getResultsFor } from './GetQueryResultsFunctions';
import ResultsLoadingManagerTVInstance from './ResultsLoadingManagerTVInstance.js';

/**
 * @typedef {import('./coreTypes').ResultAtom} ResultAtom
 * @typedef {import('./coreTypes').ResultAtomPartial} ResultAtomPartial
 * @typedef {import('./coreTypes').JSResultAtom} JSResultAtom
 * @typedef {import('./coreTypes').QuerySpec} QuerySpec
 */


/**
 * @param {number} width
 * @return {number} number of columns
 */
function determineNumberOfColumns(width)
{
	// NOTE: Depends on card display width and margins.
	for (let i = 2; i <= 200; i++) {
		const w = 443 * i + 20 * (i - 1) + 20;
		if (w > width) return i-1;
	}
	return 1;
}

/**
 * @param {number} width 
 * @return {number}
 */
function determineLeftOrRightMarginToCard(width) {
	const numOfCols = determineNumberOfColumns(width);
	const cardColWidth = 443 * numOfCols + 20 * (numOfCols - 1) + 20 - 15;
	return (width - cardColWidth) / 2;
}


/**
 * @param {QuerySpec} querySpec
 * @param {function([ResultAtom, number][][][]|null): boolean} onInitial
 * @param {function([ResultAtom, number][][][]|null): boolean} onNext
 * @param {function(string): void} onError
 * @return {void}
 */
function processQuerySpec(querySpec, onInitial, onNext, onError) {

	const convertToPaged = 
		paginator(
			window.visualViewport.height, 
			determineNumberOfColumns(window.visualViewport.width), 
			downLayoutAgentBuilder);


	const id = ResultsLoadingManagerTVInstance.generateLoadingId();
	ResultsLoadingManagerTVInstance.setActiveLoadingId(id);

	const resultObj = getResultsFor(querySpec, 1000);

	/**
	 * @type {function(ResultAtom[]): void}
	 */
	let nextHandler;

	nextHandler = res => {
		if (ResultsLoadingManagerTVInstance.getCurrentLoadingId() === id) {
			let keepGoing;
			if (res.length === 0) {
				keepGoing = onNext(null)
			} else {
				keepGoing = onNext(convertToPaged(res));
			}
			if (keepGoing) { resultObj.getNext().then(nextHandler).catch(onError); }
		}
	};

	resultObj.initial.then(res => {
		if (ResultsLoadingManagerTVInstance.getCurrentLoadingId() === id) {
			let keepGoing;
			if (res.length === 0) {
				keepGoing = onInitial(null);
			}
			else {
				keepGoing = onInitial(convertToPaged(res));
			}
			if (keepGoing) { resultObj.getNext().then(nextHandler).catch(onError); }
		}
	}).catch(onError);
}



export default processQuerySpec;
export { determineNumberOfColumns, determineLeftOrRightMarginToCard };